<template>
  <div>
    <FormLabel :prepend="prepend">
      <div class="form-control justify-content-end">
        <label class="switch align-self-center">
          <input
            :disabled="disabled"
            :checked="value"
            type="checkbox"
            @change="$emit('input', $event.target.checked)">
          <span
            :class="{'disabled': disabled}"
            class="round slider"
          />
        </label>
      </div>
    </FormLabel>
  </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel';

export default {
  name: 'FormCheckbox',
  components: { FormLabel },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    prepend: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $gray-500;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .disabled {
  background-color: darkred !important;
}

input:checked + .slider {
  background-color: $primary;
}

input:focus + .slider {
  box-shadow: 0 0 1px $primary;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

label {
  margin-bottom: 0;
}
</style>
